import { render, staticRenderFns } from "./swiper-oferta-academica.vue?vue&type=template&id=7dcd82bc&scoped=true&"
import script from "./swiper-oferta-academica.vue?vue&type=script&lang=js&"
export * from "./swiper-oferta-academica.vue?vue&type=script&lang=js&"
import style0 from "./swiper-oferta-academica.vue?vue&type=style&index=0&id=7dcd82bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcd82bc",
  null
  
)

export default component.exports